export const BOTTOM_BAR_IS_VISIBLE = 'bottom-bar-is-visible';
